import Yup from '@/yup'

// Keep in sync with Ccp::User::REGISTRATION_NAME_FORMAT in admin2b.
export const REGISTRATION_NAME_PATTERN = /^[\p{L}\p{M}]+(?:[ .'\u2019-]+[\p{L}\p{M}]+)*\.?$/u

const nameValidation = (label) => Yup.string()
  .trim()
  .max(255, `${label} darf höchstens 255 Zeichen lang sein.`)
  .matches(
    REGISTRATION_NAME_PATTERN,
    `${label} darf nur Buchstaben, Leerzeichen, Punkte, Apostrophe und Bindestriche enthalten.`,
  )
  .required(`${label} ist ein Pflichtfeld.`)

export const registrationSchema = Yup.object().shape({
  first_name: nameValidation('Vorname'),
  last_name: nameValidation('Nachname'),
  email: Yup.string()
    .trim()
    .email('Ungültige E-Mail-Adresse.')
    .required('E-Mail ist ein Pflichtfeld.'),
  password: Yup.string()
    .min(6, 'Das Passwort muss mindestens 6 Zeichen lang sein.')
    .required('Passwort ist ein Pflichtfeld.'),
  password_confirmation: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwörter müssen übereinstimmen.')
    .required('Passwort-Wiederholung ist ein Pflichtfeld.'),
  confirm_agb: Yup.boolean()
    .oneOf([true], 'AGB-Bestätigung ist ein Pflichtfeld.')
    .required('AGB-Bestätigung ist ein Pflichtfeld.'),
})

function collectMessages(value, messages) {
  if (Array.isArray(value)) {
    value.forEach((item) => collectMessages(item, messages))
    return
  }

  if (value && typeof value === 'object') {
    Object.values(value).forEach((item) => collectMessages(item, messages))
    return
  }

  if (typeof value === 'string' && value.trim()) {
    messages.push(value.trim())
  }
}

export function registrationApiErrors(payload) {
  const messages = []
  if (typeof payload === 'string' || Array.isArray(payload)) {
    collectMessages(payload, messages)
  } else {
    collectMessages(payload?.message, messages)
    collectMessages(payload?.errors, messages)
    if (typeof payload?.error === 'string') {
      collectMessages(payload.error, messages)
    }
  }
  return [...new Set(messages)]
}
